import { BUSINESS } from "@/constants/business";
import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

export default function GiftStrip() {
  const { lang } = useLang();
  const t = STRINGS[lang];
  return (
    <section data-testid="gift-strip" className="px-6 py-14 max-w-7xl mx-auto">
      <div className="relative overflow-hidden rounded-2xl border border-[#c9933b]/35 bg-gradient-to-r from-[#1a1208] via-[#120b06] to-[#0d0906] px-8 py-10 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <span className="script-accent text-2xl text-[#c9933b]">{t.gift.label}</span>
          <h3 className="serif-disp text-3xl md:text-4xl text-white font-light mt-1">{t.gift.title}</h3>
          <p className="text-neutral-400 text-sm font-light mt-3 max-w-md leading-relaxed">{t.gift.text}</p>
        </div>
        <a
          data-testid="gift-cta-btn"
          href={BUSINESS.whatsappGiftHref}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full sm:w-auto text-center shrink-0 px-7 py-4 bg-gradient-to-r from-[#c9933b] to-[#b07d4f] hover:opacity-95 text-[#0d0906] text-xs uppercase tracking-[0.2em] font-semibold rounded-lg shadow-[0_0_25px_rgba(201,147,59,0.3)] transition-all"
        >
          {t.gift.cta}
        </a>
      </div>
    </section>
  );
}
